// utils/pixelGate.ts — SATU PINTU loader fbq + gate "sukses load".
// Aturan: pixelobservasi (PageView/ViewContent/Lead) WAJIB menunggu konten
// sukses ter-render (document complete + LCP tercatat/timeout). Event
// transaksional (klik CTA, AddToCart, InitiateCheckout, Purchase-saat-Paid)
// BYPASS gate — sinyal user intent tidak boleh telat.
const FBQ_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

export function isRealFbq(): boolean {
    const f = (window as unknown as { fbq?: unknown }).fbq;
    if (typeof f !== 'function') return false;
    return typeof (f as { callMethod?: unknown }).callMethod === 'function';
}

// Stub antre + inject fbevents.js (sekali per page-load). Idempoten.
export function ensureFbq(): void {
    const w = window as unknown as Record<string, unknown>;
    if (w.fbq) return; // stub/real sudah ada — jangan timpa antrean
    const n = (w.fbq = function (this: unknown, ...args: unknown[]) {
        const q = n as unknown as {
            callMethod?: (...a: unknown[]) => void;
            queue: unknown[][];
        };
        if (q.callMethod) q.callMethod(...args);
        else q.queue.push(args);
    });
    const q = n as unknown as Record<string, unknown>;
    if (!w._fbq) w._fbq = n;
    q.push = n;
    q.loaded = true;
    q.version = '2.0';
    q.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = FBQ_SRC;
    const u = document.getElementsByTagName('script')[0];
    u?.parentNode?.insertBefore(t, u);
}

// Gate: resolve SETELAH konten sukses ter-render (window load + LCP pertama
// tercatat). Timeout aman 5 dtk agar pixel tidak hilang total di device
// lambat / LCP tak tercatat. Browser tanpa PerformanceObserver → fallback
// ke gate load-only (tanpa penalti 5 dtk).
export function waitForContentReady(timeoutMs = 5000): Promise<void> {
    return new Promise((resolve) => {
        let done = false;
        let lcpSeen = false;
        const finish = () => {
            if (done) return;
            done = true;
            resolve();
        };
        const timer = setTimeout(finish, timeoutMs);
        void timer;
        const maybeFinish = () => {
            if (document.readyState !== 'complete' || !lcpSeen) return;
            // Load + LCP → beri 1 frame agar paint selesai sebelum inject.
            requestAnimationFrame(() => requestAnimationFrame(finish));
        };
        try {
            if (typeof PerformanceObserver === 'undefined') throw new Error('no-po');
            const po = new PerformanceObserver((list) => {
                const entries = list.getEntries();
                for (let i = 0; i < entries.length; i++) {
                    if (entries[i].entryType === 'largest-contentful-paint') {
                        lcpSeen = true;
                        try { po.disconnect(); } catch { /* abaikan */ }
                        maybeFinish();
                        break;
                    }
                }
            });
            po.observe({ type: 'largest-contentful-paint', buffered: true });
        } catch {
            // Observer tak didukung / tipe tak dikenal → fallback load-only.
            lcpSeen = true;
        }
        const onReady = () => {
            if (document.readyState !== 'complete') return;
            maybeFinish();
        };
        if (document.readyState === 'complete') onReady();
        else window.addEventListener('load', onReady, { once: true });
    });
}
